"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmountLimitOptions = exports.AMOUNT_LIMIT_OPTIONS = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
exports.AMOUNT_LIMIT_OPTIONS = [50, 100, 250, 500, 1000, 5000];
var useAmountLimitOptions = function () {
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    return (0, react_1.useMemo)(function () {
        return exports.AMOUNT_LIMIT_OPTIONS.reduce(function (acc, option, idx) {
            var _a;
            var _b;
            return (__assign(__assign({}, acc), (_a = {}, _a[idx] = "".concat((0, apps_shared_1.getCurrencySymbol)(currentCurrency)).concat((_b = (Number(option) || 0)) === null || _b === void 0 ? void 0 : _b.toFixed(0)), _a)));
        }, {});
    }, [currentCurrency]);
};
exports.useAmountLimitOptions = useAmountLimitOptions;
